import momentToDateFns from './momentToDateFns'

export const funeralHomeDateFormat = (format: string): string =>
  momentToDateFns(format) || 'MMMM do yyyy'

export default funeralHomeDateFormat
